<template>
  <a-modal
    title="继续修改计划"
    :visible="visible"
    :footer="null"
    class="edit-confirm"
    @cancel="handleCancel"
  >
    <a-alert
      message="创建新修改计划后，上次未提交的修改计划将被删除"
      type="warning"
      banner
      show-icon
    />
    <p class="tips">上次的修改计划暂未提交，是否继续？</p>
    <div class="modal-bottom">
      <a-button @click="onAdd">新修改计划</a-button>
      <a-button type="primary" class="submit-btn" @click="onSubmit">继续修改</a-button>
    </div>
  </a-modal>
</template>

<script>

export default {
  name: 'EditConfirm',
  data() {
    return {
      visible: false,
      editRecord: null,
      planEditHistory: {},
    }
  },
  methods: {
    show(record, planEditHistory = {}) {
      this.editRecord = record
      this.planEditHistory = planEditHistory
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    onAdd() {
      delete this.planEditHistory[this.editRecord.id]
      localStorage.setItem('planEditHistory', JSON.stringify(this.planEditHistory))
      this.$emit('changeEdit', this.editRecord, this.planEditHistory)
      this.handleCancel()
    },
    onSubmit() {
      this.$emit('changeEdit', this.editRecord, this.planEditHistory)
      this.handleCancel()
    },
  }
}
</script>

<style lang="less" scoped>
.edit-confirm {
  /deep/ .ant-modal-body {
    padding: 0;
    .ant-alert {
      color: #FF7D00;
      background: #FFF2E5;
    }
    .ant-alert-message, .ant-alert-icon {
      color: #FF7D00;
    }
  }
  .tips {
    margin: 24px 0 0 24px;
    color: #000F25
  }
  .modal-bottom {
    padding: 24px;
    text-align: right;
    .submit-btn {
      margin-left: 12px;
    }
  }
}
</style>